import React from 'react';
import './Title.css';

function Title({title}) {
  return (
    <div className='acp-title'>
      { title }
    </div>
  );
}

export default Title;